
import React from 'react';
import * as classes from './CustomTableBox.module.scss';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { CustomAppEventListener } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import { getIconsForData } from "Flow2/components/CustomCollections/CustomDataControllers/CustomMediaController";
import { getSortedData } from "Flow2/components/CustomCollections/CustomDataControllers/CustomSortController";
import { FormattedMessage } from 'react-intl';
import { faSort, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CustomTableHeaderIcon = (props) => {
    let icon = null;
    let data = props.data || "";
    if (props.dataId)
        icon = getIconsForData(props.dataId);
    else
        icon = getIconsForData(data.toLowerCase());

    if (icon) return <FontAwesomeIcon icon={icon} style={{ marginRight: '10px' }} />
    else return <div />
}

/*
 * TABLE: MEDIAFILES
 */

export const CustomTableMf = (props) => {
    return (
        <div className={classes.CustomTableMfContainer}>
            {props.children}
        </div>
    )
}

export const CustomTableMfBody = (props) => {
    return (
        <div className={classes.CustomTableMfBodySection}>
            {props.children}
        </div>
    )
}

export const showTableMfInfo = (data, formatMessage) => {
    const elementStyle = '<div style="border:1px solid #f7f7f7; border-top: none; font-size: 12px; color: #aaaaaa; text-align:left; padding: 2px;">';
    const divStyle = '<div style="border-top:1px solid #f7f7f7;">';
    const textStyle = '<span style="color: black;">';
    let infos = data.reduce((acc, item) => {
        let addTo = "";
        if (item[0].includes("datarate")) addTo = " kbit/s";
        if (item[0].includes("samplerate")) addTo = " Hz";
        let newItem = formatMessage({ id: `customdata.${item[0]}` });
        if (newItem === `customdata.${item[0]}`) newItem = item[0];
        acc = acc + elementStyle + textStyle + DataUtil.writeName(newItem) + '</span>' + ' : ' + item[1] + addTo + '</div>';
        return acc;
    }, '');
    return (divStyle + infos + '</div>')
}

export const convertMfInfo = (obj, term) => {
    let data = null;
    if (obj && obj.props && obj.props.children)
        data = obj.props.children;
    if (data) {
        let tmp1 = DataUtil.subStringAfter(data, "|");
        let tmp2 = DataUtil.subStringAfter(tmp1, "|");
        switch (term) {
            case "resolution":
                return DataUtil.subStringBefore(data, "|");
            case "filesize":
                return DataUtil.subStringBefore(tmp1, "|");
            case "aspectratio":
                return DataUtil.subStringBefore(tmp2, "|");
            case "format":
                return DataUtil.subStringAfter(tmp2, "|");
        }
    }
    return "-";
}

export const getMfSortedData = ({ data, name, sorted, appLang, tempConfig }) => {
    return getSortedData({ data, name, sorted, appLang, tempConfig });
}

export const setMfInitState = (data) => {
    let initData = { ...data };
    for (let i in initData) {
        if (initData[i]) initData[i] = false;
    }

    return initData;
}

export const setMfSortIcon = (data, name) => {
    let faChevronDown = CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faChevronDown");
    let faChevronUp = CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faChevronUp");
    let icon = faChevronDown
    if (data) icon = faChevronUp;
    if (name === CustomTypes.ID) {
        if (data) icon = faChevronDown;
        else icon = faChevronUp;
    }
    return icon;
}

/**
 * TABLE: CLIPLIST_LIST
 */
export const getGridMfHeaderData = () => {
    let headerData = [
        [{ ID: "thumbnail", DE: "Vorschaugrafik", EN: "Thumbnail", RU: "Миниатюру" }],
        [{ ID: "title", DE: "Titel/ Länge/ Größe", EN: "Title/ Duration/ Size", RU: "Название/ Длина/ размер", isBr: true }],
        [{ ID: "uploaddate", DE: "Uploaddate", EN: "Upload Date", RU: "Дата загрузки", clicked: true, sorted: CustomTypes.SORT_DEFAULT }],
        [{ ID: "uploader", DE: "Uploader", EN: "Uploader", RU: "Дата загрузки" }],
        [{ ID: "status", DE: "Status/ Rechte", EN: "Status/ Rights", RU: "Статус/права" }],
        [{ ID: "resolution", DE: "Auflösung/ Format", EN: "Resolution/ Format", RU: "Резолюция/Формат", isBr: true }],
        [{ ID: "videolanguages", DE: "Sprachversionen", EN: "Video Languages", RU: "Языки" }],
        [{ ID: "filterpublished", DE: "Published", EN: "Filter Published", RU: "Дата загрузки", published: true }],
        [{ ID: "actions", DE: "Aktionen", EN: "Actions", RU: "Действия" }]
    ]
    return headerData;
}

export const getHeaderDataForTable = () => {
    let headerData = [
        [{ ID: "thumbnail", DE: "Vorschaugrafik", EN: "Thumbnail", RU: "Миниатюру" }],
        [{ ID: "title", DE: "Titel/ Länge/ Größe", EN: "Title/ Duration/ Size", RU: "Название/ Длина/ размер" }],
        [{ ID: "uploaddate", DE: "Uploaddatum", EN: "Upload Date", RU: "Дата загрузки" }],
        [{ ID: "status", DE: "Status/ Rechte", EN: "Status/ Rights", RU: "Статус/права" }],
        [{ ID: "resolution", DE: "Auflösung/ Format", EN: "Resolution/ Format", RU: "Резолюция/Формат" }],
        [{ ID: "videolanguages", DE: "Sprachversionen", EN: "Video Languages", RU: "Языки" }],
        [{ ID: "actions", DE: "Aktionen", EN: "Actions", RU: "Действия" }],
    ]

    if (DataUtil.isVifogra()) headerData = getGridMfHeaderData();

    return headerData;
}

export const getClassName = (data) => {
    let className;
    switch (data) {
        case CustomTypes.THUMB:
            className = "CustomTableColumnThumb";
            break;
        case CustomTypes.TITLE:
            className = "CustomTableColumnTitle";
            break;
        case CustomTypes.STATUS:
            className = "CustomTableColumnStatus";
            break;
        default:
            className = "CustomTableColumn";
            break;
    }

    return className;
}

export const getClickOptions = ({ props, item }) => {
    if (item[0].clicked && props.onItemClick(item)) return props.onItemClick(item);
    if (item[0].published && props.onPublishedClick(item)) return props.onPublishedClick(item);
    return null;
}

export const setGridMfActive = ({ item }) => {
    if (item[0].clicked || item[0].published) return classes.GridMfTableBrHeadeClickColumn;
    if (item[0].isBr) return classes.GridMfTableBrHeaderColumn;
    return classes.GridMfTableColumn
}

export const showGridMfTableHeader = (props) => {
    let data = props.data;
    let lg = DataUtil.getLanguage(props.lg);

    if (DataUtil.isVifogra()) {
        return (
            <div className={classes.CustomTableHeaderContainer}>
                <div className={classes.GridMfTableHeaderBox}>
                    {data.map(item => <div className={setGridMfActive({ item })}
                        onClick={getClickOptions({ props, item })}>
                        {item[0].clicked && <FontAwesomeIcon icon={faSort} />}
                        {item[0].published && <FontAwesomeIcon icon={faUsers} />}
                        {props.noIcon ? <div /> : <CustomTableHeaderIcon dataId={item[0].ID} data={item[0][lg]} />}
                        <span>{DataUtil.writeName(item[0][lg])}</span>
                    </div>)}
                </div>
            </div>
        )
    }
}


export const CustomClipsTableHeader = (props) => {
    let data = props.data;
    let lg = DataUtil.getLanguage(props.lg);
    if (DataUtil.isVifogra()) return showGridMfTableHeader(props);
    return (
        <div className={classes.CustomTableHeaderContainer}>
            <div className={classes.CustomTableHeaderRow}>
                {data.map(item => <div className={classes[getClassName(item[0].ID)]}>{props.noIcon ? <div /> : <CustomTableHeaderIcon dataId={item[0].ID} data={item[0][lg]} />}{DataUtil.writeName(item[0][lg])}</div>)}
            </div>
        </div>
    )
}

export const CustomTableLargeTitle = (props) => {
    return (<div className={classes.CustomTableBodyColumnContainer}>
        <div className={classes.CustomTableTitleBox}>
            <div className={classes.CustomTableTitleText} data-text={props.data}>
                <input type="text" value={props.data} />
            </div>
        </div>
    </div>)
}

/*
* TABLE: HISTORY
*/

export const CustomTableHeader = (props) => {
    let data = props.data;
    let tableName = 'history';
    if (props.tableName) tableName = props.tableName;
    return (
        <div className={classes.TableSubRow}>
            {data.map(item => <div className={classes.TableDataHeader}>
                {props.noIcon ? <div /> : <CustomTableHeaderIcon data={item[0]} />}
                {props.isLang ? <FormattedMessage id={`customdata.${tableName}.${item[0]}`} />
                    : DataUtil.writeName(item[0])}</div>)}
        </div>
    )
}

export const CustomTableWithHeaderRow = (props) => {
    let data = props.data;
    let tableName = 'history';
    if (props.tableName) tableName = props.tableName;
    return (
        <div>
            {(props.isFirst) ? <CustomTableHeader isLang={props.isLang} isFirst={props.isFirst}
                data={props.data} tableName={tableName} /> : <div />}
            <div className={classes.TableRow}>
                {data.map((item) => <div className={classes.TableColumn}><div className={classes.TableSubRow}>
                    <div className={classes.TableDataContent}>{(props.isLang && item[0] === "action" && item[1] !== "")
                        ? <FormattedMessage id={`customdata.${tableName}.${item[1]}`} /> : item[1]}</div></div></div>)}
            </div>
        </div>
    )
}

export const CustomTableWithHeader = (props) => {
    let data = props.data || [];
    let isLang = false;
    let tableName = 'history';
    if (props.tableName) tableName = props.tableName;
    if (props.isLang) isLang = true;
    if (data.length > 0) {
        return (
            <div style={{ display: props.display ? props.display : "block" }} className={classes.PageTableSection}>
                {data.map((item, index) => {
                    return <CustomTableWithHeaderRow isLang={isLang} isFirst={(index === 0) ? true : false}
                        data={Object.entries(item)} tableName={tableName} />
                })}

            </div>
        )
    } else return (<div />)
}
